"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SlideshowItem = exports.SlideshowButton = exports.SetNavButtonPositions = exports.CustomIndicator = void 0;
var SlideMethods = _interopRequireWildcard(require("./Slideshow"));
var _ArrowBackIosNew = _interopRequireDefault(require("@mui/icons-material/ArrowBackIosNew"));
var _ArrowForwardIos = _interopRequireDefault(require("@mui/icons-material/ArrowForwardIos"));
var _reactMaterialUiCarousel = _interopRequireDefault(require("react-material-ui-carousel"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _string = require("../../utils/type-checks/string");
var _useElementSize = require("./../../utils/hooks/useElementSize");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  CustomIndicator = props => {
    const {
      label = "Select Slide",
      testId
    } = props;
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      component: "span",
      "data-testid": testId,
      sx: {
        left: "-9999px !important",
        overflow: "hidden !important",
        position: "absolute !important",
        top: "-9999px !important"
      }
    }, label);
  },
  SetNavButtonPositions = (elem, theme) => {
    const padding = 40,
      navButtonArray = [...document.querySelectorAll(".Slideshow__nav-button-wrapper")],
      rect = typeof elem?.getBoundingClientRect === "function" ? elem.getBoundingClientRect() : null;
    let adjustment = 0;
    navButtonArray.forEach(item => {
      adjustment += item.offsetWidth + padding;
    });
    if (rect && rect.left && rect.width && rect.width + adjustment <= window?.innerWidth) {
      navButtonArray.filter(item => {
        return item.querySelectorAll("[aria-label=\"Next\"]").length > 0;
      }).forEach(item => {
        item.style.left = `${rect.left + rect.width + padding}${theme.breakpoints.unit}`;
        item.style.right = "unset";
      });
      navButtonArray.filter(item => {
        return item.querySelectorAll("[aria-label=\"Previous\"]").length > 0;
      }).forEach(item => {
        item.style.left = `${rect.left - adjustment / 2}${theme.breakpoints.unit}`;
        item.style.right = "unset";
      });
    } else {
      navButtonArray.forEach(item => {
        item.style.left = "";
        item.style.right = "";
      });
    }
    return rect;
  },
  SlideshowItem = props => {
    const {
        children,
        childrenBefore = true,
        customTheme = {},
        height,
        paddingColumn = "left",
        slideData = {},
        testId
      } = props,
      theme = merge((0, _styles.useTheme)(), customTheme),
      {
        buttonData,
        fragmentId = false,
        label,
        slideChildren,
        styles = {},
        tag = "h2"
      } = slideData,
      defaultStyles = {
        alignItems: "flex-start",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderRadius: "0",
        boxShadow: "unset",
        display: "flex",
        flexDirection: "column",
        fontSize: {
          xs: "2.8rem",
          md: "3.2rem"
        },
        minHeight: `${height}px`,
        justifyContent: "center",
        overflow: "hidden",
        padding: {
          xs: "1rem 2rem",
          md: "1rem 12rem"
        },
        "> *": merge(theme.mixins.container.inner, {
          maxWidth: `${theme.breakpoints.values.lg}${theme.breakpoints.unit}`,
          padding: {
            xs: "0",
            md: paddingColumn !== "left" ? "0 0 0 33%" : "0 33% 0 0"
          },
          textAlign: {
            xs: "center",
            md: "left"
          },
          width: "100%"
        })
      },
      componentStyles = merge(defaultStyles, styles),
      result = fragmentId || slideChildren || children ? /*#__PURE__*/_react.default.createElement(_material.Paper, {
        "data-testid": testId,
        sx: componentStyles,
        "data-padding-column": testId ? paddingColumn : undefined
      }, label && /*#__PURE__*/_react.default.createElement(_material.Typography, {
        component: tag,
        className: "Slideshow-item__header",
        "data-testid": `${testId}__header`
      }, label), /*#__PURE__*/_react.default.createElement(_material.Box, {
        component: "div",
        className: "Slideshow-item__content",
        "data-testid": `${testId}__content`
      }, childrenBefore === true && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, slideChildren), fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
        id: fragmentId
      }), childrenBefore !== true && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, slideChildren)), buttonData && /*#__PURE__*/_react.default.createElement(_material.Box, {
        component: "div",
        className: "Slideshow-item__footer",
        sx: {
          paddingTop: "2rem"
        },
        "data-testid": `${testId}__footer`
      }, /*#__PURE__*/_react.default.createElement(SlideshowButton, {
        buttonData: buttonData
      }))) : /*#__PURE__*/_react.default.createElement("div", {
        hidden: true,
        "data-testid": testId
      });
    return result;
  },
  SlideshowButton = props => {
    const {
        buttonData = {},
        testId
      } = props,
      {
        label,
        path,
        url,
        variant = "primary"
      } = buttonData,
      result = label && (path || url) ? /*#__PURE__*/_react.default.createElement(_material.Button, {
        className: (0, _string.isStringOfLength)(path) ? "Slideshow__button--isLink" : "Slideshow__button--isAnchor",
        component: (0, _string.isStringOfLength)(path) ? _reactRouterDom.Link : "a",
        "data-testid": testId,
        to: path,
        href: url,
        sx: {
          marginLeft: "0",
          marginRight: "0"
        },
        target: (0, _string.isStringOfLength)(path) ? undefined : "_blank",
        variant: variant
      }, label) : /*#__PURE__*/_react.default.createElement("div", {
        hidden: true,
        "data-testid": testId
      });
    return result;
  };

/**
 * Slideshow component, built upon React Material UI Carousel.
 * For more details and configuration options, view [React Material UI Carousel Read Me](https://github.com/Learus/react-material-ui-carousel/blob/master/README.md)
 *
 * @visibleName Slideshow
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.SlideshowButton = SlideshowButton;
exports.SlideshowItem = SlideshowItem;
exports.SetNavButtonPositions = SetNavButtonPositions;
exports.CustomIndicator = CustomIndicator;
const Slideshow = props => {
  const {
      activeIndicatorIconButtonProps = {
        style: {
          backgroundColor: "rgba(0, 115, 176, 1)"
        }
      },
      customTheme = {},
      height = 500,
      IndicatorIcon = /*#__PURE__*/_react.default.createElement(CustomIndicator, null),
      indicators = true,
      indicatorContainerProps = {
        className: "Slideshow__indicator-container"
      },
      indicatorIconButtonProps = {
        style: {
          backgroundColor: "rgba(56, 56, 56, 0.14)",
          border: "0.2rem solid rgba(151, 151, 151, 0.76)",
          borderRadius: "0.2rem",
          color: "blue",
          fontSize: "12rem",
          height: "0.7rem",
          margin: "0 0.8rem",
          padding: "0",
          width: "4.2rem"
        }
      },
      interval = 10000,
      label,
      limitNavButtonPosition = false,
      navButtonsAlwaysVisible = true,
      navButtonsProps = {
        className: "Slideshow__nav-button"
      },
      navButtonsWrapperProps = {
        className: "Slideshow__nav-button-wrapper",
        style: {
          background: "none !important",
          height: "auto"
        }
      },
      NextIcon = /*#__PURE__*/_react.default.createElement(_ArrowForwardIos.default, null),
      PrevIcon = /*#__PURE__*/_react.default.createElement(_ArrowBackIosNew.default, null),
      slideArray,
      stopAutoPlayOnHover = false,
      styles = {},
      swipe = true,
      tag = "h2",
      testId,
      ...rest
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    defaultStyles = merge(theme.mixins.container.outer, {
      padding: "0 !important",
      ".Slideshow__indicator-container": {
        padding: "0",
        position: "relative",
        top: {
          xs: "-4rem",
          md: "-5rem"
        }
      },
      ".Slideshow__nav-button": {
        backgroundColor: "rgba(0, 0, 0, 0.2) !important",
        display: {
          xs: "none",
          md: "inline-flex"
        },
        filter: "unset",
        height: "6.9rem",
        opacity: "1 !important",
        transition: "none",
        width: "6.9rem",
        "svg": {
          height: "5rem",
          width: "3.2rem"
        },
        "&:hover,&:active,&:focus-visible": {
          backgroundColor: "rgba(0, 0, 0, 0.3) !important",
          opacity: "1 !important"
        }
      }
    }),
    componentStyles = merge(defaultStyles, styles),
    [containerRef, {
      width
    }] = (0, _useElementSize.useElementSize)();
  (0, _react.useLayoutEffect)(() => {
    if (limitNavButtonPosition) {
      const indicatorContainer = document.querySelectorAll(".Slideshow__indicator-container");
      if (indicatorContainer.length > 0) {
        SlideMethods.SetNavButtonPositions(indicatorContainer[0], theme);
      }
    }
  }, [limitNavButtonPosition, theme, width]);
  return /*#__PURE__*/_react.default.createElement(_material.Container, {
    className: "Slideshow",
    "data-testid": testId,
    sx: componentStyles,
    ref: containerRef
  }, label && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Slideshow__header",
    component: tag
  }, label), /*#__PURE__*/_react.default.createElement(_reactMaterialUiCarousel.default, _extends({
    activeIndicatorIconButtonProps: activeIndicatorIconButtonProps,
    className: "Slideshow__content",
    fullHeightHover: false,
    height: height,
    IndicatorIcon: IndicatorIcon,
    indicators: indicators,
    indicatorContainerProps: merge(indicatorContainerProps, {
      className: "Slideshow__indicator-container",
      style: {
        margin: "0 auto",
        maxWidth: `${theme.breakpoints.values.lg}${theme.breakpoints.unit}`,
        zIndex: "3"
      }
    }),
    indicatorIconButtonProps: indicatorIconButtonProps,
    interval: interval,
    navButtonsAlwaysVisible: navButtonsAlwaysVisible,
    navButtonsProps: navButtonsProps,
    navButtonsWrapperProps: navButtonsWrapperProps,
    NextIcon: NextIcon,
    PrevIcon: PrevIcon,
    stopAutoPlayOnHover: stopAutoPlayOnHover,
    swipe: swipe
  }, rest), slideArray.map((slide, i) => /*#__PURE__*/_react.default.createElement(SlideshowItem, {
    customTheme: customTheme,
    height: height,
    key: `Slideshow__slide-key--${i}`,
    slideData: slide
  }))));
};

// Define propTypes;
Slideshow.propTypes = {
  /** Custom properties to adjust active indicator (Default Value: {style: {backgroundColor: "rgba(0, 115, 176, 1)"}}) */
  activeIndicatorIconButtonProps: _propTypes.default.object,
  /** Type of animated slide transition */
  animation: _propTypes.default.oneOf(["fade", "slide"]),
  /** Boolean that enables slide autoplay behavior */
  autoPlay: _propTypes.default.bool,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Content fragment ID for inclusion of content */
  fragmentId: _propTypes.default.string,
  /** Sets fixed height of the carousel component (Default Value: 500) */
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /** Component encapsulating slide indicator icon (Default Value: <CustomIndicator />) */
  IndicatorIcon: _propTypes.default.node,
  /** Boolean to render/hide indicators (Default Value: true) */
  indicators: _propTypes.default.bool,
  /** Custom object for adjusting indicator icons wrapper (Default Value: {className: "Slideshow__indicator-container"}) */
  indicatorContainerProps: _propTypes.default.object,
  /** Custom object for adjusting indicator icons (Default Value: Object containing Style Object) */
  indicatorIconButtonProps: _propTypes.default.object,
  /** Milliseconds between slide transitions (Default Value: 10000) */
  interval: _propTypes.default.number,
  /** Heading text */
  label: _propTypes.default.string,
  /** Boolean to limit/control nav button placement (Default Value: false) */
  limitNavButtonPosition: _propTypes.default.bool,
  /** Boolean to keep Navigation Buttons always visible (Default Value: true) */
  navButtonsAlwaysVisible: _propTypes.default.bool,
  /** Custom properties for Navigation Icon Buttons (Default Value: {className: "Slideshow__nav-button"} */
  navButtonsProps: _propTypes.default.object,
  /** Custom properties for div surrounding Navigation Icon Buttons (Default Value: Props Object containing className and Style Object) */
  navButtonsWrapperProps: _propTypes.default.object,
  /** Component encapsulating next slide icon image (Default Value: <ArrowForwardIosIcon />) */
  NextIcon: _propTypes.default.node,
  paddingColumn: _propTypes.default.oneOf(["left", "right"]),
  /** Component encapsulating previous slide icon image (Default Value: <ArrowBackIosNewIcon />) */
  PrevIcon: _propTypes.default.node,
  /** Array of objects with individual slide properties */
  slideArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Button properties or false if deactiviting button */
    buttonData: _propTypes.default.shape({
      /** Button Label */
      label: _propTypes.default.string.isRequired,
      /** Internal path if target is a React Route */
      path: _propTypes.default.string,
      /** @ignore */
      testId: _propTypes.default.string,
      /** External URL if there is no path */
      url: _propTypes.default.string,
      /** Button variant */
      variant: _propTypes.default.string
    }),
    /** Heading text */
    label: _propTypes.default.string,
    /** Any child elements to insert into individual slides */
    slideChildren: _propTypes.default.any,
    /** Headding Tag */
    tag: _propTypes.default.string
  })).isRequired,
  /** Boolean to pause slide autoPlay while hovering over slideshow (Default Value: false) */
  stopAutoPlayOnHover: _propTypes.default.bool,
  /** Custom styles object for component (Default Value: {}) */
  styles: _propTypes.default.object,
  /** Boolean to enable/disable mobile swipe behavior (Default Value: true) */
  swipe: _propTypes.default.bool,
  /** Heading component tag (Default Value: "h2") */
  tag: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};
SlideshowItem.propTypes = {
  children: _propTypes.default.any,
  childrenBefore: _propTypes.default.bool,
  customTheme: _propTypes.default.object,
  slide: _propTypes.default.shape({
    buttonData: _propTypes.default.object,
    fragmentId: _propTypes.default.string,
    label: _propTypes.default.string,
    slideChildren: _propTypes.default.any,
    tag: _propTypes.default.string
  }),
  styles: _propTypes.default.object,
  tag: _propTypes.default.string,
  testId: _propTypes.default.string
};
SlideshowButton.propTypes = {
  buttonData: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    path: _propTypes.default.string,
    testId: _propTypes.default.string,
    url: _propTypes.default.string,
    variant: _propTypes.default.string
  })
};

// Export component as default;
var _default = exports.default = Slideshow;